const PayyoTipMode = Object.freeze({
    FIXED: 'fixed',
    PERCENTAGE: 'percentage',
    SMART: 'smart',
});

module.exports = PayyoTipMode;
